export const INDICATORS_MAPPING = [
  {
    identifier: 'l',
    title: "Lucro",
    subtitle: "É o valor que sobra para a empresa depois de subtrair todos os custos das receitas.",
    tooltip: `<strong>Lucro (L)</strong> = Receita Total (RT) - Custo Total (CT)`,
    type: 'currency'
  },
  {
    identifier: 'lt',
    title: "Lucratividade",
    subtitle: "Mede o quanto a empresa consegue gerar lucro em relação ao que investe ou fatura.",
    type: 'percent'
  },
  {
    identifier: 'rtm',
    title: "Rentabilidade",
    subtitle: "Mede o retorno que a empresa obtém sobre um investimento realizado.",
    tooltip: `<strong>Rentabilidade = Lucro (L)</strong> / Investimento Total (IT)`,
    type: 'percent'
  },
  {
    identifier: 'pri',
    title: "Prazo de Retorno do Investimento (anual)",
    subtitle: "Mede em quanto tempo o investimento inicial é recuperado por meio dos resultados gerados",
    type: 'days'
  },
  {
    identifier: 'ncg',
    title: "Necessidade de Capital de Giro",
    subtitle: "Mede quanto a empresa precisa manter disponível para financiar suas operações do dia a dia sem faltar dinheiro.",
    type: 'currency'
  },
  {
    identifier: 'nfcg',
    title: "Necessidade de Formação de Capital de Giro",
    subtitle: "Mede quanto de capital precisa formar para sustentar o crescimento das operações sem faltar recursos.",
    type: 'currency'
  },
  {
    identifier: 'fluxgraph',
    title: "Capacidade de Pagamento",
    subtitle: "Mede a habilidade da empresa de honrar seus compromissos financeiros com os recursos que possui.",
    type: 'currency'
  }
]
export const FILTER_OPTIONS = [
  {
    id: 0,
    label: "Selecione",
    monthAmt: 0,
  },
  {
    id: 1,
    label: "Últimos 3 meses",
    monthAmt: 3,
  },
  {
    id: 2,
    label: "Últimos 6 meses",
    monthAmt: 6,
  },
  {
    id: 3,
    label: "Últimos 9 meses",
    monthAmt: 9,
  },
  {
    id: 4,
    label: "Últimos 12 meses",
    monthAmt: 12,
  },
]
export const FLUXGRAPH_FILTER_OPTIONS = [
  {
    id: 1,
    label: "3 meses",
    monthAmt: 3,
  },
  {
    id: 2,
    label: "6 meses",
    monthAmt: 6,
  },
  {
    id: 3,
    label: "9 meses",
    monthAmt: 9,
  },
  {
    id: 4,
    label: "12 meses",
    monthAmt: 12,
  },
]
export const optionsPeriod = [
  {
    id: 0,
    label: "Últimas edições",
    monthAmt: 0,
  },
  {
    id: 1,
    label: "Últimos 3 meses",
    monthAmt: 3,
  },
  {
    id: 2,
    label: "Últimos 6 meses",
    monthAmt: 6,
  },
  {
    id: 3,
    label: "Últimos 9 meses",
    monthAmt: 9,
  },
  {
    id: 4,
    label: "Últimos 12 meses",
    monthAmt: 12,
  },
]
export const optionsOrderBy = [
  {
    id: 0,
    label: "Data de criação (mais novo - mais antigo)",
    order: "sort_by_created_at=desc"
  },
  {
    id: 1,
    label: "Data de criação (mais antigo - mais novo)",
    order: "sort_by_created_at=asc"
  },
  {
    id: 2,
    label: "Nome (A - Z)",
    order: "sort_by_title=asc"
  },
  {
    id: 3,
    label: "Nome (Z - A)",
    order: "sort_by_title=desc"
  },
]
export const monthNames = [
  "Janeiro",
  "Fevereiro",
  "Março",
  "Abril",
  "Maio",
  "Junho",
  "Julho",
  "Agosto",
  "Setembro",
  "Outubro",
  "Novembro",
  "Dezembro",
]
